import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

/**
 * StickyCTA — bottom-fixed CTA bar. Appears after the user scrolls past the hero.
 *
 * Props:
 *   - href:    target URL or hash (default "/foundersignaltest")
 *   - label:   button label (default "Take the Founder Signal Test — Free →")
 *   - meta:    small line above the button (optional)
 *   - showAfter: scrollY in px after which the bar appears (default 600)
 */
export default function StickyCTA({
  href = "/foundersignaltest",
  label = "Take the Founder Signal Test — Free →",
  meta = "Free · 5 minutes · Instant result",
  showAfter = 600,
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > showAfter);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [showAfter]);

  // Use SPA <Link> for internal routes (preserves analytics in-flight requests).
  // Fall back to <a> for hash/external links.
  const isInternalRoute = typeof href === "string" && href.startsWith("/") && !href.startsWith("//");

  return (
    <div
      className={`sticky-cta ${visible ? "sticky-cta--visible" : ""}`}
      data-testid="sticky-cta"
      aria-hidden={!visible}
    >
      <div className="sticky-cta__inner">
        {isInternalRoute ? (
          <Link
            to={href}
            className="sticky-cta__btn sticky-cta__btn--full"
            data-testid="sticky-cta-button"
          >
            {label}
          </Link>
        ) : (
          <a
            href={href}
            className="sticky-cta__btn sticky-cta__btn--full"
            data-testid="sticky-cta-button"
          >
            {label}
          </a>
        )}
      </div>
    </div>
  );
}
